import React, { useEffect } from 'react';
import { CONSTANTS } from 'services/constants';
const { FORM_ID, PORTAL_ID } = CONSTANTS.DATA.BUSINESS_LOGIC.HUBSPOT_FORM;

const GetQuoteHubspotForm = () =>
{
    useEffect(() =>
    {
        const script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        script.onload = () =>
        {
            if (window.hbspt)
            {
                window.hbspt.forms.create({
                    region: 'na1',
                    portalId: PORTAL_ID,
                    formId: FORM_ID,
                    target: '#hubspotForm',
                });
            }
        };
        document.body.appendChild(script);
    }, []);

    return <div id="hubspotForm"></div>;
};

export default GetQuoteHubspotForm;
